import { Container } from "react-bootstrap";
import { Route, Routes } from "react-router-dom";
import PageLayout from "./components/PageLayout/PageLayout";
import AccountSettingsPage from "./pages/AccountSettingsPage/AccountSettingsPage";
import AdminCartsPage from "./pages/Admin/AdminCartPage/AdminCartPage";
import AdminDebugFieldPage from "./pages/Admin/AdminDebugFieldPage/AdminDebugFieldPage";
import AdminPage from "./pages/AdminPage/AdminPage";
import CartPaymentPage from "./pages/CartPaymentPage/CartPaymentPage";
import Error404Page from "./pages/Error404Page/Error404Page";
import ExportCartPage from "./pages/ExportCartPage/ExportCartPage";
import InvestorSearchPage from "./pages/InvestorSearchPage/InvestorSearchPage";
import JortsPage from "./pages/JortsPage/JortsPage";
import PodcastsHomePage from "./pages/PodcastsHomePage/PodcastsHomePage";
import ProjectPage from "./pages/ProjectPage/ProjectPage";
import PublicListingPage from "./pages/PublicListingPage/PublicListingPage";
import StripeConnectPage from "./pages/StripeConnectPage/StripeConnectPage";
import VCDirectoryHomePage from "./pages/VCDirectoryHomePage/VCDirectoryHomePage";

const AppRoutes = () => {
  return (
    <PageLayout>
      <Container className="app-home-page" fluid="sm">
        <Routes>
          {/* Admin routes */}
          <Route path="/admin/carts" element={<AdminCartsPage />} />
          <Route path="/admin/debug-field" element={<AdminDebugFieldPage />} />
          <Route path="/admin" element={<AdminPage />} />

          {/* Hooks */}
          <Route path="/connect/stripe" element={<StripeConnectPage />} />

          {/* Public routes */}
          <Route path="/account/settings" element={<AccountSettingsPage />} />
          <Route path="/account" element={<AccountSettingsPage />} />
          <Route path="/cart/:cartId" element={<CartPaymentPage />} />
          <Route path="/cart" element={<ExportCartPage />} />
          <Route path="/find-vc" element={<VCDirectoryHomePage />} />
          <Route path="/home" element={<VCDirectoryHomePage />} />
          <Route path="/investors/search" element={<InvestorSearchPage />} />
          <Route path="/podcasts" element={<PodcastsHomePage />} />
          <Route path="/projects/:projectId/jorts" element={<JortsPage />} />
          <Route path="/project/:projectId/public-listing" element={<PublicListingPage />} />
          <Route path="/project/:projectId" element={<ProjectPage />} />
          <Route path="*" element={<Error404Page />} />
        </Routes>
      </Container>
    </PageLayout>
  );
};

export default AppRoutes;
